import { InjectionToken } from '@angular/core';
import { PhoneNumberDisplayContext } from '../models';

export const PHONE_NUMBER_DISPLAY_CONTEXT =
  new InjectionToken<PhoneNumberDisplayContext>('phone-number-display-context');
